import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: auto;
    padding: 0 0 16px;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const Wrapper = styled.div`
    width: 100%;
    height: auto;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ContainerAcordions = styled.div`
    width: 100%;
    height: auto;
    max-width: 850px;
    padding: 16px;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ContainerAcordionCard = styled.div`
    width: 100%;
    height: auto;
    max-width: 400px;
    padding: 16px 0 0;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ContainerModal = styled.div`
    width: 100%;
    height: auto;
    max-width: 480px;
    padding: 16px 0 0;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;

    >ul>li{
        text-align: left;
    }
`;

export const ContainerLoading = styled.div`
    width: 100%;
    height: 400px;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 80px;
  height: 80px;
  position: relative;

  background-color: transparent;
  border-top: 1px solid #2fbb69;
  border-bottom: 1px solid #2fbb69;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;